import DeclineAllMeetingsModal from './DeclineAllMeetingsModal'

export default DeclineAllMeetingsModal
